export default __webpack_public_path__ + "static/media/luaRoxa.fe1ada5f.png";